import { Component, OnInit, ViewChild, computed, inject } from "@angular/core";
import { FormularGroupTabContentComponent } from "../tab-content.interface";
import { CommonKeys } from "../../../formular-model/common/enums";
import { NewOrEditArtikelPopupComponent } from "./popup/popup.component";
import {
  FormularArtikelAktion,
  FormularGroupArtikel,
} from "../../../formular-model/formular-groups/interfaces/FormularGroupArtikel";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import { FormularGroupArtikelTableComponent } from "./table/table.component";
import { ItemRequest, ItemResult } from "./artikel.types";
import { AlertService } from "src/app/services";

@Component({
  selector: "tab-formular-group-artikel",
  templateUrl: "./artikel.component.html",
  styleUrls: ["./artikel.component.scss"],
  standalone: false,
})
export class FormularGroupArtikelComponent
  extends FormularGroupTabContentComponent<FormularGroupArtikel>
  implements OnInit
{
  override formularGroupDataKey = "Artikel";

  private _popup = inject(CstResponsivePopupService);
  private _snackBar = inject(AlertService);

  @ViewChild("table") table!: FormularGroupArtikelTableComponent;

  public artikel = computed(
    () => this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values],
  );

  private tableData = computed(() => {
    return this.table.data.data;
  });

  addingCustomItem = false;
  addingCatalogueItem = false;

  itemActions: { label: string; value: any }[] = [];

  ngOnInit(): void {
    this.__dataInternal = { ...this.data };
    this.__dataInternal["MaterialActionNames"].forEach((a: any) =>
      this.itemActions.push({
        label: a.DisplayName,
        value: FormularArtikelAktion[a.EnumName],
      }),
    );
  }

  onAddItemFromCatalogue() {
    // TODO: implement catalogue items whenever backend infrastructure is ready
    this.addingCatalogueItem = true;
    this._snackBar.showSnackbar("Not implemented yet");
  }

  onCancelItem() {
    this.addingCatalogueItem = false;
    this.addingCustomItem = false;
  }

  onAddCustomItem() {
    this.addingCustomItem = true;

    const dialogRef = this._popup.open<
      NewOrEditArtikelPopupComponent,
      ItemRequest,
      ItemResult | null
    >(NewOrEditArtikelPopupComponent, {
      data: {
        state: "new",
        data: null,
        actions: this.itemActions,
      },
    });

    return dialogRef.afterClosed().subscribe({
      next: (result) => this._handleNewItem(result as ItemResult),
      error: (error) => this._handleError(error),
    });
  }

  private _handleNewItem(newItemResult: ItemResult) {
    if (!newItemResult || !newItemResult.state || !newItemResult.data) return;

    this.table.data.data.push(newItemResult.data);

    this.table.refresh();
  }

  private _handleError(error) {
    // TODO: points of failure (if any) have to be identified and handled accordingly
    this._snackBar.Error(error);
  }

  public reconstructData(): FormularGroupArtikel {
    const res = {
      [CommonKeys.Type]: this.data[CommonKeys.Type],
      [CommonKeys.ID]: this.data[CommonKeys.ID],
      [CommonKeys.Label]: this.data[CommonKeys.Label],
      [CommonKeys.ShowLabel]: this.data[CommonKeys.ShowLabel],
      Artikel: {
        [CommonKeys.Type]: this.data["Artikel"][CommonKeys.Type],
        [CommonKeys.Values]: this.tableData(),
      },
    };

    return res;
  }
}
